import { fetchJson } from "src/utils/apiUtils";
import {
  IRemyndBrandPartnerMapFullData,
  IRemyndBrandPartnerMapSaveReq
} from "./types";

const endpoint = `master/remyndBrandPartnerMap`;

export const listFullData = async (partnerId: PartnerId) => {
  return fetchJson<IResponse<IRemyndBrandPartnerMapFullData>>(
    `${endpoint}/listFullData?partnerId=${partnerId}`,
    { method: "GET" }
  );
};

export const save = async (req: IRemyndBrandPartnerMapSaveReq) => {
  return fetchJson<IResponse<RemyndBrandPartnerMapId>>(`${endpoint}/save`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const update = async (
  id: RemyndBrandPartnerMapId,
  req: IRemyndBrandPartnerMapSaveReq
) => {
  return fetchJson<IResponse<RemyndBrandPartnerMapId>>(
    `${endpoint}/update/${id}`,
    {
      method: "POST",
      body: JSON.stringify({ ...req })
    }
  );
};

export const deleteMultiple = async (req: ICommonIdsReq) => {
  return fetchJson<IResponse<null>>(`${endpoint}/delete`, {
    method: "DELETE",
    body: JSON.stringify({ ...req })
  });
};
